import PropTypes from 'prop-types';
import * as React from 'react';
import {connect} from 'react-redux';

import {UserFilters} from './UserFilters';
import {getServiceUrls} from 'src/js/containers/filter_and_search/filter_and_search_selectors';
import {
  loadUserFilters,
  removeUserFilter,
  useUserFilter,
  setDefaultUserFilter,
} from 'src/js/containers/filtering/filtering_actions';
import {
  getLoadedHierarchyChildrenLabels,
  getUserFiltersByType,
  getUserFiltersLoadingByType,
} from 'src/js/containers/filtering/filtering_selectors';

class UserFiltersContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.removeUserFilter = this.removeUserFilter.bind(this);
    this.reloadUserFilters = this.reloadUserFilters.bind(this);
    this.setDefaultUserFilter = this.setDefaultUserFilter.bind(this);
    this.useUserFilter = this.useUserFilter.bind(this);
  }

  componentDidUpdate(prevProps) {
    const {serviceUrlsBySelector} = this.props;
    if (
      serviceUrlsBySelector.userFilterType &&
      prevProps.serviceUrlsBySelector.userFilterType !==
        serviceUrlsBySelector.userFilterType
    ) {
      this.reloadUserFilters(this.props);
    }
  }

  setDefaultUserFilter(filter, value) {
    const {config, filteringStateId, serviceUrlsBySelector} = this.props;
    this.props.setDefaultUserFilter(
      filteringStateId,
      config.service.url.userFilters,
      serviceUrlsBySelector.userFilterType,
      filter.getId(),
      value
    );
  }

  removeUserFilter(filter) {
    const {config, filteringStateId, serviceUrlsBySelector} = this.props;
    this.props.removeUserFilter(
      filteringStateId,
      config.service.url.userFilters,
      serviceUrlsBySelector.userFilterType,
      filter.getId()
    );
  }

  reloadUserFilters(props) {
    const {config, filteringStateId, serviceUrlsBySelector} = props;
    this.props.loadUserFilters(
      filteringStateId,
      config.service.url.userFilters,
      serviceUrlsBySelector.userFilterType
    );
  }

  useUserFilter(filter) {
    const {filteringStateId, filterAndSearchStateId, serviceUrlsBySelector} =
      this.props;
    this.props.useUserFilter(
      filteringStateId,
      filterAndSearchStateId,
      serviceUrlsBySelector.searchService,
      filter.getValue()
    );
  }

  render() {
    const {
      autocompleteValues,
      hierarchyChildrenLabels,
      schema,
      userFilters,
      userFiltersLoading,
    } = this.props;
    return (
      <UserFilters
        autocompleteValues={autocompleteValues}
        hierarchyChildrenLabels={hierarchyChildrenLabels}
        removeFilter={this.removeUserFilter}
        schema={schema}
        setDefaultFilter={this.setDefaultUserFilter}
        useFilter={this.useUserFilter}
        userFilters={userFilters}
        userFiltersLoading={userFiltersLoading}
      />
    );
  }
}

UserFiltersContainer.displayName = 'UserFiltersContainer';

/* eslint-disable react/no-unused-prop-types */
UserFiltersContainer.propTypes = {
  config: PropTypes.objectOf(PropTypes.any).isRequired,
  filteringStateId: PropTypes.string.isRequired,
  filterAndSearchStateId: PropTypes.string.isRequired,
  serviceUrls: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default connect(
  (state, props) => ({
    autocompleteValues: state[props.filteringStateId].autocompleteValues,
    hierarchyChildrenLabels: getLoadedHierarchyChildrenLabels(state, props),
    schema: state[props.filteringStateId].schema,
    serviceUrlsBySelector: getServiceUrls(state, props),
    userFilters: getUserFiltersByType(state, props),
    userFiltersLoading: getUserFiltersLoadingByType(state, props),
  }),
  {
    loadUserFilters,
    removeUserFilter,
    useUserFilter,
    setDefaultUserFilter,
  }
)(UserFiltersContainer);
